import { useContext, useRef } from 'react';
import { BrazeContext } from 'containers/BrazeProvider';
import { InboxNotificationType } from 'constants/index';
import { clickEvent, viewEvent } from 'libs/common/event-tracker/events';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { ViewableElement } from 'constants/tracking/viewable-elements';
import useTracking from './useTracking';

const useInboxNotificationEvents = () => {
  const {
    track
  } = useTracking();
  const {
    logCardClick,
    logCardImpression,
    inboxNotificationCardStore
  } = useContext(BrazeContext);
  const seenNotificationIds = useRef([]);

  const handleNotificationClick = notification => () => {
    switch (notification.type) {
      case InboxNotificationType.Vinted:
        track(clickEvent({
          target: ClickableElement.Notification,
          targetDetails: JSON.stringify({
            notification_id: notification.id
          })
        }));
        break;

      case InboxNotificationType.Braze:
        {
          if (!notification.link) return;
          logCardClick(notification.id);
          break;
        }

      default:
        break;
    }
  };

  const handleNotificationEnter = notification => () => {
    const isNotificationSeen = seenNotificationIds.current.includes(notification.id);
    if (!isNotificationSeen) seenNotificationIds.current.push(notification.id);
    const targetDetails = {
      notification_id: notification.id
    };

    switch (notification.type) {
      case InboxNotificationType.Vinted:
        if (isNotificationSeen) break;
        track(viewEvent({
          target: ViewableElement.Notification,
          targetDetails: JSON.stringify(targetDetails)
        }));
        break;

      case InboxNotificationType.Braze:
        {
          const viewedBefore = notification.isViewed;
          logCardImpression(notification.id).then(isLogged => {
            if (!isLogged || viewedBefore) return;

            if (inboxNotificationCardStore.state) {
              inboxNotificationCardStore.state = Array.from(inboxNotificationCardStore.state);
            }
          });
          break;
        }

      default:
        break;
    }
  };

  return {
    onClick: handleNotificationClick,
    onEnter: handleNotificationEnter
  };
};

export default useInboxNotificationEvents;